'use client'

import React, { createContext, useContext, useEffect } from 'react'

type PlayCircleFlags = {
  circleEnabled: boolean
  playdatesEnabled: boolean
  notificationsMarkReadEnabled: boolean
}

const PlayCircleFlagContext = createContext<PlayCircleFlags>({
  circleEnabled: false,
  playdatesEnabled: false,
  notificationsMarkReadEnabled: false,
})

export type PlayCircleFlagProviderProps = {
  /** Resolved on the server from PLAY_CIRCLE_ENABLED at request time. */
  circleEnabled: boolean
  /** Resolved on the server from PLAY_CIRCLE_PLAYDATES_ENABLED at request time. */
  playdatesEnabled?: boolean
  /** Resolved on the server from PLAY_NOTIFICATIONS_MARK_READ_ENABLED at request time. */
  notificationsMarkReadEnabled?: boolean
  children: React.ReactNode
}

export function PlayCircleFlagProvider({
  circleEnabled,
  playdatesEnabled = false,
  notificationsMarkReadEnabled = false,
  children,
}: PlayCircleFlagProviderProps) {
  useEffect(() => {
    console.log(
      `[PlayCircleFlag] context circle=${circleEnabled} playdates=${playdatesEnabled} markRead=${notificationsMarkReadEnabled}`
    )
  }, [circleEnabled, playdatesEnabled, notificationsMarkReadEnabled])

  return (
    <PlayCircleFlagContext.Provider
      value={{ circleEnabled, playdatesEnabled, notificationsMarkReadEnabled }}
    >
      <span
        data-play-circle-server-flag={circleEnabled ? 'true' : 'false'}
        data-play-circle-playdates-server-flag={playdatesEnabled ? 'true' : 'false'}
        data-play-notifications-mark-read-server-flag={
          notificationsMarkReadEnabled ? 'true' : 'false'
        }
        hidden
        aria-hidden="true"
      />
      {children}
    </PlayCircleFlagContext.Provider>
  )
}

/** Client hook — value is fixed for the session from App Beta layout SSR. */
export function usePlayCircleEnabled(): boolean {
  return useContext(PlayCircleFlagContext).circleEnabled
}

/** Client hook — Circle playdates persistence UI gate (Phase 3.1B). */
export function usePlayCirclePlaydatesEnabled(): boolean {
  return useContext(PlayCircleFlagContext).playdatesEnabled
}

/** Client hook — Activity Center mark-read gate (Phase 1 notifications). */
export function usePlayNotificationsMarkReadEnabled(): boolean {
  return useContext(PlayCircleFlagContext).notificationsMarkReadEnabled
}
